import React from 'react'
import { Link } from 'react-router-dom'
import s from '../css/auth.module.css'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import Loader from './Loader'

const ResetPassword = ({
	hasToken,
	isPassShow,
	setPassShow,
	handleSubmit,
	handleChange,
	values,
	errors,
	disabled,
	status,
}) => {
	if (!hasToken) {
		return (
			<div className={s.container}>
				<div className='common__body'>
					<h3>Сброс пароля</h3>
					<p className={s.hint}>Ссылка недействительна или устарела</p>
					<div className={s.links}>
						<Link to='/forgot-password'>Запросить новую ссылку</Link>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className={s.container}>
			<div className='common__body'>
				<h3>Сброс пароля</h3>
				<form action='' onSubmit={e => handleSubmit(e)}>
					<div className={s.input}>
						<input
							type={isPassShow ? 'text' : 'password'}
							placeholder='Новый пароль'
							autoComplete='new-password'
							onChange={e => handleChange(e)}
							defaultValue={values.password}
							name='password'
							id='password'
						/>

						<div className={s.eye} onClick={setPassShow}>
							{isPassShow ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
						</div>

						{errors.password && (
							<label htmlFor='password'>{errors.password} </label>
						)}
					</div>

					<div className={s.input}>
						<input
							type={isPassShow ? 'text' : 'password'}
							placeholder='Повторите пароль'
							autoComplete='new-password'
							onChange={e => handleChange(e)}
							defaultValue={values.repeatPassword}
							name='repeatPassword'
							id='repeatPassword'
						/>

						<div className={s.eye} onClick={setPassShow}>
							{isPassShow ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
						</div>

						{errors.repeatPassword && (
							<label htmlFor='repeatPassword'>{errors.repeatPassword} </label>
						)}
					</div>

					<div className={s.btn}>
						<button id='btn' disabled={disabled || status.isLoading}>
							{status.isLoading ? (
								<Loader isButton={true} />
							) : (
								'Сохранить пароль'
							)}
						</button>

						{status.message && status.message !== 'ok' && (
							<label htmlFor='btn'>{status.message}</label>
						)}
					</div>
				</form>

				{status.message && status.message !== 'ok' && (
					<div className={s.links}>
						<Link to='/forgot-password'>Запросить новую ссылку</Link>
					</div>
				)}
			</div>
		</div>
	)
}

export default ResetPassword
